import { useNavigate } from 'react-router-dom';

export default function CheckoutCancel() {
  const navigate = useNavigate();
  return (
    <div style={{
      color: 'white',
      minHeight: '80vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      gap: '16px',
      padding: '40px 20px',
    }}>
      <p style={{ fontSize: '0.85rem', letterSpacing: '0.1em', textTransform: 'uppercase', opacity: 0.5, margin: 0 }}>
        Payment Cancelled
      </p>
      <h1 style={{ fontSize: '2rem', margin: 0 }}>No charge made.</h1>
      <p style={{ opacity: 0.45, maxWidth: '380px', lineHeight: 1.7, fontSize: '0.9rem', margin: 0 }}>
        Your payment was cancelled and you haven't been charged. Head back and try again whenever you're ready.
      </p>
      <button
        onClick={() => navigate(-1)}
        style={{
          marginTop: '16px',
          background: 'none',
          color: 'white',
          border: '1px solid #555',
          padding: '12px 28px',
          fontSize: '0.85rem',
          letterSpacing: '0.08em',
          cursor: 'pointer',
          fontFamily: 'inherit',
        }}
      >
        Go Back
      </button>
    </div>
  );
}
